export const FREE_ALIGNMENT_SERVICE = 'free-alignment-check'
